import { useRef } from "react";

import { Button } from "components/Button/Button";
import { Dialog } from "components/Dialog/Dialog";
import { DialogActionsBar } from "components/Dialog/DialogActionsBar";

import "./Dialogs.scss";

interface Props {
  onCancel: () => void;
  onDiscard: () => void;
}

export const DiscardChangesDialog = ({ onCancel, onDiscard }: Props): JSX.Element => {
  const dialogContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={dialogContainerRef} data-testid="discard-changes-dialog">
      <Dialog
        appendTo={dialogContainerRef.current}
        className="found-opened-encounter"
        onClose={onCancel}
        title="Discard changes"
      >
        <p>Are you sure you want to discard changes?</p>
        <DialogActionsBar>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={onDiscard} danger>
            Discard & Close
          </Button>
        </DialogActionsBar>
      </Dialog>
    </div>
  );
};
